module.exports = __webpack_public_path__ + "img/optik_w.baea2de8.svg";